import React from "react";
import PropTypes from "prop-types";
import style from "../style.module.scss";
import { generateRulerPoints } from "../RangeSlider.utils";

export function Scale(props) {
  const scalePoints = React.useMemo(
    () => generateRulerPoints(props.min, props.max, props.scaleInterval),
    [props.min, props.max, props.scaleInterval]
  );

  const getStyle = (value) => props.getPostionLeft(value);

  const renderPoint = (point) => (
    <div key={point} className={style.rulerPoint} style={getStyle(point)}>
      <p>
        {point.toString()}
        {` ${props.unit}`}
      </p>
    </div>
  );

  return scalePoints.map(renderPoint);
}

Scale.propTypes = {
  /**
   * The unit of the unit
   */
  unit: PropTypes.string,
  /**
   * Input range min value
   */
  min: PropTypes.number,

  /**
   * Input range max value
   */
  max: PropTypes.number,
  /**
   * Input range scaleInterval value
   */
  scaleInterval: PropTypes.number,
  /**
   * Function to calculate Position Left value
   */
  getPostionLeft: PropTypes.func,
};
